export default __webpack_public_path__ + "static/media/discord.79388188.svg";